import { useContext, useState } from "react"
import { LanguageContext, NotificationContext } from "../context"
import { submitContactForm } from "../services/messaging"
import { Link } from "react-router-dom"

const AgreementsModal = ({ onSubmit }) => {

  const { t } = useContext(LanguageContext)
  const { toast } = useContext(NotificationContext)

  const [loading, setLoading] = useState(false)
  const [agreementsChecked, setAgreementsChecked] = useState(false)

  const handleSubmit = async () => {
    if(!agreementsChecked) {
      toast({ message: t('auth.accept_cgu'), variant: 'error' })
      return
    }
    setLoading(true)
    await onSubmit()
    setLoading(false)
  }

  return (
    <div className="w-full">
      <div
        className="justify-center items-center z-60 rounded-lg modal-container ">
        <div className="flex items-start justify-between pt-16 pb-9 px-5  ">
          <h3 className="modal-title">
            {t('agreements.title')}
          </h3>
        </div>
        <div className="pt-4 px-10 pb-8">
          <p className='content-text !text-center mx-auto'>
            {t('agreements.text')}
          </p>
        </div>
        <div className="modal-box mt-2">
          <div className="modal-body">
            <div className='mb-6 custom-checkbox'>
              <div className='flex gap-5 relative'>
                <input type='checkbox' name='terms' id='condition' checked={agreementsChecked} onChange={e => setAgreementsChecked(e.target.checked)} />
                <label className='block mb-2 condition' htmlFor='condition'>
                  {`${t('auth.accept_label1')} `}
                  <Link to={'/CGU_Application WeCar.pdf'} target='_blank' className='link'>{t('auth.accept_label_cgu')}</Link>
                  {` ${t('auth.accept_label2')} `}
                  <Link to={'/Politique de confidentialité_WeCar.pdf'} target='_blank' className='link'>{t('auth.accept_label_pp')}</Link>
                  {` ${t('auth.accept_label3')}`}
                </label>
              </div>
            </div>
            <div className="flex gap-4 mt-6">
              <button
                className={`flex primary mid btn-loading ${loading ? 'running' : ''}`}
                onClick={handleSubmit}
              >
                <div className="loading"></div>
                {t('agreements.submit')}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-50 modal-bg"></div>
    </div>
  )
}

export default AgreementsModal
